// 4个认证
        document.addEventListener('DOMContentLoaded', function() {
            const container = document.querySelector('.trust-badges-container');
            const section = document.querySelector('.trust-badges-section');
            
            // Check if mobile
            const isMobile = window.innerWidth <= 768;
            
            if (isMobile) {
                // Add scroll hint animation on first load
                setTimeout(() => {
                    section.classList.add('show-hint');
                }, 500);
                
                // Remove hint after animation
                setTimeout(() => {
                    section.classList.remove('show-hint');
                }, 2500);
                
                // Optional: Add touch scroll indicators
                let isScrolling;
                container.addEventListener('scroll', function() {
                    window.clearTimeout(isScrolling);
                    container.style.cursor = 'grabbing';
                    
                    isScrolling = setTimeout(function() {
                        container.style.cursor = 'grab';
                    }, 150);
                });
                
                // Set initial cursor
                container.style.cursor = 'grab';
            }
            
            // Click tracking
            document.querySelectorAll('.trust-badge-item').forEach(badge => {
                badge.addEventListener('click', function() {
                    const badgeText = this.querySelector('.trust-badge-text').textContent;
                    console.log('Badge clicked:', badgeText);
                    // Add your tracking or action code here
                });
            });
            
            // Optional: Programmatic scroll buttons (if needed)
            function addScrollButtons() {
                if (!isMobile) return;
                
                const wrapper = document.querySelector('.trust-badges-wrapper');
                
                // Create scroll buttons
                const scrollLeftBtn = document.createElement('button');
                scrollLeftBtn.innerHTML = '‹';
                scrollLeftBtn.className = 'scroll-btn scroll-btn-left';
                scrollLeftBtn.style.cssText = `
                    position: absolute;
                    left: 5px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: white;
                    border: none;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    font-size: 20px;
                    cursor: pointer;
                    z-index: 2;
                    display: none;
                `;
                
                const scrollRightBtn = document.createElement('button');
                scrollRightBtn.innerHTML = '›';
                scrollRightBtn.className = 'scroll-btn scroll-btn-right';
                scrollRightBtn.style.cssText = `
                    position: absolute;
                    right: 5px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: white;
                    border: none;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    font-size: 20px;
                    cursor: pointer;
                    z-index: 2;
                `;
                
                // Add buttons to wrapper
                wrapper.style.position = 'relative';
                wrapper.appendChild(scrollLeftBtn);
                wrapper.appendChild(scrollRightBtn);
                
                // Scroll functionality
                scrollLeftBtn.addEventListener('click', () => {
                    container.scrollBy({ left: -250, behavior: 'smooth' });
                });
                
                scrollRightBtn.addEventListener('click', () => {
                    container.scrollBy({ left: 250, behavior: 'smooth' });
                });
                
                // Show/hide buttons based on scroll position
                function updateButtons() {
                    const maxScroll = container.scrollWidth - container.clientWidth;
                    scrollLeftBtn.style.display = container.scrollLeft > 0 ? 'block' : 'none';
                    scrollRightBtn.style.display = container.scrollLeft < maxScroll - 1 ? 'block' : 'none';
                }
                
                container.addEventListener('scroll', updateButtons);
                updateButtons();
            }
            
            // Uncomment to add scroll buttons
            // addScrollButtons();
        });


// 第二部分
<!-- Optional JavaScript for animations on scroll -->
        document.addEventListener('DOMContentLoaded', function() {
            // Intersection Observer for animation on scroll
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const elementsToAnimate = document.querySelectorAll('.telework-stat-card');
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.style.opacity = '0';
                            entry.target.style.transform = 'translateY(20px)';
                            
                            setTimeout(() => {
                                entry.target.style.transition = 'all 0.5s ease';
                                entry.target.style.opacity = '1';
                                entry.target.style.transform = 'translateY(0)';
                            }, 100 * index);
                        }, 100);
                        
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            
            elementsToAnimate.forEach(element => {
                element.style.opacity = '0';
                observer.observe(element);
            });

            // Number counter animation
            function animateNumber(element, target, duration = 2000) {
                const start = 0;
                const increment = target / (duration / 16);
                let current = start;
                
                const timer = setInterval(() => {
                    current += increment;
                    if (current >= target) {
                        element.textContent = target + '%';
                        clearInterval(timer);
                    } else {
                        element.textContent = Math.floor(current) + '%';
                    }
                }, 16);
            }

            // Trigger number animation when stats come into view
            const statNumbers = document.querySelectorAll('.telework-stat-number');
            const numberObserver = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const text = entry.target.textContent;
                        const number = parseInt(text);
                        if (!isNaN(number)) {
                            animateNumber(entry.target, number);
                        }
                        numberObserver.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            statNumbers.forEach(element => {
                numberObserver.observe(element);
            });
        });

// 第三部分

document.addEventListener('DOMContentLoaded', function() {
            // Intersection Observer for animation on scroll
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const cards = document.querySelectorAll('.criteria-card');
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.style.opacity = '0';
                        entry.target.style.transform = 'translateY(30px)';
                        
                        setTimeout(() => {
                            entry.target.style.transition = 'all 0.6s ease';
                            entry.target.style.opacity = '1';
                            entry.target.style.transform = 'translateY(0)';
                        }, 100);
                        
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            
            // Only observe if not already animated
            cards.forEach(card => {
                if (!card.classList.contains('animated')) {
                    observer.observe(card);
                }
            });

            // Click tracking for analytics (optional)
            cards.forEach(card => {
                card.addEventListener('click', function() {
                    const title = this.querySelector('.criteria-card-title').textContent;
                    const number = this.getAttribute('data-number');
                    console.log(`Criteria card clicked: ${number} - ${title}`);
                    // Add your analytics tracking here
                });
            });

            // Optional: Add tooltips on hover
            const highlights = document.querySelectorAll('.criteria-highlight');
            highlights.forEach(highlight => {
                highlight.addEventListener('mouseenter', function() {
                    this.style.transform = 'scale(1.02)';
                    this.style.transition = 'transform 0.2s ease';
                });
                
                highlight.addEventListener('mouseleave', function() {
                    this.style.transform = 'scale(1)';
                });
            });
        });


// 第三部分
document.addEventListener('DOMContentLoaded', function() {
            // Card hover effect with tilt
            const cards = document.querySelectorAll('.tech-style-card');
            
            cards.forEach(card => {
                card.addEventListener('mousemove', function(e) {
                    const rect = this.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
                    
                    const centerX = rect.width / 2;
                    const centerY = rect.height / 2;
                    
                    const rotateX = (y - centerY) / 10;
                    const rotateY = (centerX - x) / 10;
                    
                    this.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-10px) scale(1.02)`;
                });
                
                card.addEventListener('mouseleave', function() {
                    this.style.transform = '';
                });
            });

            // Color chip click animation
            const colorChips = document.querySelectorAll('.tech-color-chip');
            
            colorChips.forEach(chip => {
                chip.addEventListener('click', function() {
                    const color = this.getAttribute('data-color');
                    
                    // Create ripple effect
                    const ripple = document.createElement('div');
                    ripple.style.position = 'absolute';
                    ripple.style.width = '100%';
                    ripple.style.height = '100%';
                    ripple.style.borderRadius = '8px';
                    ripple.style.background = 'rgba(255, 255, 255, 0.5)';
                    ripple.style.animation = 'rippleOut 0.6s ease-out';
                    
                    this.appendChild(ripple);
                    
                    setTimeout(() => {
                        ripple.remove();
                    }, 600);
                    
                    console.log(`Color selected: ${color}`);
                });
            });

            // Add ripple animation
            const style = document.createElement('style');
            style.textContent = `
                @keyframes rippleOut {
                    from {
                        transform: scale(0);
                        opacity: 1;
                    }
                    to {
                        transform: scale(2);
                        opacity: 0;
                    }
                }
            `;
            document.head.appendChild(style);

            // Stats counter animation
            const stats = document.querySelectorAll('.tech-stat-number');
            
            const observerOptions = {
                threshold: 0.5,
                rootMargin: '0px'
            };
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const target = entry.target;
                        const value = parseInt(target.textContent);
                        let current = 0;
                        
                        const increment = value / 50;
                        const timer = setInterval(() => {
                            current += increment;
                            if (current >= value) {
                                target.textContent = value + '%';
                                clearInterval(timer);
                            } else {
                                target.textContent = Math.floor(current) + '%';
                            }
                        }, 30);
                        
                        observer.unobserve(target);
                    }
                });
            }, observerOptions);
            
            stats.forEach(stat => {
                observer.observe(stat);
            });
        });

// 第四部分
        document.addEventListener('DOMContentLoaded', function() {
            // Intersection Observer for animations
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const animatedElements = document.querySelectorAll('.usage-scenario-box, .usage-comparison-card');
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.style.opacity = '0';
                            entry.target.style.transform = 'translateY(30px)';
                            
                            setTimeout(() => {
                                entry.target.style.transition = 'all 0.6s ease';
                                entry.target.style.opacity = '1';
                                entry.target.style.transform = 'translateY(0)';
                            }, 100);
                        }, index * 100);
                        
                        observer.unobserve(entry.target);
                    }
                    // Buy button click handlers
            const buyButtons = document.querySelectorAll('.usage-buy-button');
            buyButtons.forEach((button, index) => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    const productNames = ['Sihoo Doro S100', 'Sihoo Doro C300', 'Sihoo Doro S300'];
                    const productPrices = ['449€', '649€', '799€'];
                    
                    console.log(`Acheter: ${productNames[index]} - Prix: ${productPrices[index]}`);
                    
                    // Visual feedback - ripple effect
                    const ripple = document.createElement('span');
                    ripple.style.position = 'absolute';
                    ripple.style.width = '20px';
                    ripple.style.height = '20px';
                    ripple.style.background = 'rgba(255, 255, 255, 0.5)';
                    ripple.style.borderRadius = '50%';
                    ripple.style.transform = 'translate(-50%, -50%)';
                    ripple.style.pointerEvents = 'none';
                    ripple.style.animation = 'rippleEffect 0.6s ease-out';
                    
                    const rect = this.getBoundingClientRect();
                    ripple.style.left = (e.clientX - rect.left) + 'px';
                    ripple.style.top = (e.clientY - rect.top) + 'px';
                    
                    this.appendChild(ripple);
                    
                    setTimeout(() => {
                        ripple.remove();
                    }, 600);
                    
                    // Here you can add actual purchase logic
                    // window.location.href = `/products/${productNames[index].toLowerCase().replace(/ /g, '-')}`;
                    // Or open in modal, add to cart, etc.
                });
            });

            // Add ripple animation to style
            const style = document.createElement('style');
            style.textContent = `
                @keyframes rippleEffect {
                    from {
                        width: 20px;
                        height: 20px;
                        opacity: 0.5;
                    }
                    to {
                        width: 200px;
                        height: 200px;
                        opacity: 0;
                    }
                }
            `;
            document.head.appendChild(style);
        });
            }, observerOptions);
            
            animatedElements.forEach(element => {
                element.style.opacity = '0';
                observer.observe(element);
            });

            // Click tracking for analytics
            const scenarioBoxes = document.querySelectorAll('.usage-scenario-box');
            scenarioBoxes.forEach((box, index) => {
                box.addEventListener('click', function() {
                    const title = this.querySelector('.usage-scenario-title').textContent;
                    console.log(`Scenario clicked: ${index + 1} - ${title}`);
                    // Add your analytics tracking here
                });
            });

            // Price tag animation on hover
            const priceTags = document.querySelectorAll('.usage-price-tag');
            priceTags.forEach(tag => {
                tag.addEventListener('mouseenter', function() {
                    this.style.transform = 'scale(1.1)';
                    this.style.transition = 'transform 0.2s ease';
                });
                
                tag.addEventListener('mouseleave', function() {
                    this.style.transform = 'scale(1)';
                });
            });

            // Comparison card click handler
            const comparisonCards = document.querySelectorAll('.usage-comparison-card');
            comparisonCards.forEach(card => {
                card.addEventListener('click', function() {
                    const title = this.querySelector('.usage-comparison-title').textContent;
                    const value = this.querySelector('.usage-comparison-value').textContent;
                    console.log(`Comparison card clicked: ${title} - ${value}`);
                    
                    // Visual feedback
                    this.style.transform = 'scale(1.05)';
                    setTimeout(() => {
                        this.style.transform = 'scale(1)';
                    }, 200);
                });
            });
        });


// 第五部分
document.addEventListener('DOMContentLoaded', function() {
            // Intersection Observer for animations
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const animatedElements = document.querySelectorAll('.price-range-card, .price-warning-box');
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.style.opacity = '0';
                        entry.target.style.transform = 'translateY(30px)';
                        
                        setTimeout(() => {
                            entry.target.style.transition = 'all 0.6s ease';
                            entry.target.style.opacity = '1';
                            entry.target.style.transform = 'translateY(0)';
                        }, 100);
                        
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            
            animatedElements.forEach(element => {
                observer.observe(element);
            });

            // Card click handler
            const priceCards = document.querySelectorAll('.price-range-card');
            priceCards.forEach(card => {
                card.addEventListener('click', function() {
                    const title = this.querySelector('.price-card-title').textContent;
                    const range = this.querySelector('.price-card-amount').textContent;
                    console.log(`Price range selected: ${title} - ${range}`);
                    
                    // Visual feedback
                    this.style.transform = 'scale(0.98)';
                    setTimeout(() => {
                        this.style.transform = '';
                    }, 200);
                    
                    // You can add navigation or filtering logic here
                });
            });

            // Hover effect for feature items
            const featureItems = document.querySelectorAll('.price-feature-item');
            featureItems.forEach(item => {
                item.addEventListener('mouseenter', function() {
                    this.style.paddingLeft = '40px';
                    this.style.transition = 'padding-left 0.2s ease';
                });
                
                item.addEventListener('mouseleave', function() {
                    this.style.paddingLeft = '35px';
                });
            });

            // Parallax effect for background elements
            if (window.innerWidth > 768) {
                const wrapper = document.querySelector('.price-analysis-wrapper');
                
                window.addEventListener('scroll', () => {
                    const scrolled = window.pageYOffset;
                    const rate = scrolled * -0.3;
                    
                    if (wrapper && wrapper.offsetTop < scrolled + window.innerHeight) {
                        const before = wrapper.querySelector('::before');
                        const after = wrapper.querySelector('::after');
                        
                        if (before) {
                            wrapper.style.setProperty('--before-transform', `translate(${rate * 0.5}px, ${rate}px)`);
                        }
                        if (after) {
                            wrapper.style.setProperty('--after-transform', `translate(${rate * -0.5}px, ${rate * -1}px)`);
                        }
                    }
                });
            }
        });

// 第六部分

        document.addEventListener('DOMContentLoaded', function() {
            // Table row hover effect
            const tableRows = document.querySelectorAll('.comparison-table tbody tr');
            
            tableRows.forEach(row => {
                row.addEventListener('click', function() {
                    const modelName = this.querySelector('td:first-child strong').textContent;
                    console.log(`Model selected: ${modelName}`);
                    
                    // Visual feedback
                    this.style.transform = 'scale(1.02)';
                    setTimeout(() => {
                        this.style.transform = '';
                    }, 200);
                });
            });

            // Mobile card interaction
            const mobileCards = document.querySelectorAll('.comparison-mobile-card');
            
            mobileCards.forEach(card => {
                card.addEventListener('click', function() {
                    const modelName = this.querySelector('.comparison-mobile-card-title').textContent;
                    console.log(`Mobile card selected: ${modelName}`);
                    
                    // Add pulse effect
                    this.style.animation = 'pulse 0.3s ease';
                    setTimeout(() => {
                        this.style.animation = '';
                    }, 300);
                });
            });

            // Add pulse animation
            const style = document.createElement('style');
            style.textContent = `
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(0.98); }
                    100% { transform: scale(1); }
                }
            `;
            document.head.appendChild(style);

            // Intersection Observer for scroll animations
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.style.opacity = '0';
                        entry.target.style.transform = 'translateY(20px)';
                        
                        setTimeout(() => {
                            entry.target.style.transition = 'all 0.5s ease';
                            entry.target.style.opacity = '1';
                            entry.target.style.transform = 'translateY(0)';
                        }, 100);
                        
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            
            // Observe mobile cards
            mobileCards.forEach(card => {
                observer.observe(card);
            });

            // Horizontal scroll indicator for desktop table
            const scrollContainer = document.querySelector('.comparison-table-scroll');
            if (scrollContainer) {
                scrollContainer.addEventListener('scroll', function() {
                    const maxScroll = this.scrollWidth - this.clientWidth;
                    const currentScroll = this.scrollLeft;
                    
                    if (currentScroll > 0 && currentScroll < maxScroll) {
                        this.style.boxShadow = 'inset 2px 0 5px rgba(0,0,0,0.1), inset -2px 0 5px rgba(0,0,0,0.1)';
                    } else if (currentScroll === 0) {
                        this.style.boxShadow = 'inset -2px 0 5px rgba(0,0,0,0.1)';
                    } else if (currentScroll === maxScroll) {
                        this.style.boxShadow = 'inset 2px 0 5px rgba(0,0,0,0.1)';
                    }
                });
            }

            // Table sticky header on scroll
            const table = document.querySelector('.comparison-table');
            const tableWrapper = document.querySelector('.comparison-table-scroll');
            
            if (table && tableWrapper && window.innerWidth > 768) {
                const thead = table.querySelector('thead');
                const theadClone = thead.cloneNode(true);
                theadClone.style.position = 'fixed';
                theadClone.style.top = '0';
                theadClone.style.display = 'none';
                theadClone.style.zIndex = '100';
                tableWrapper.appendChild(theadClone);
                
                window.addEventListener('scroll', () => {
                    const tableRect = table.getBoundingClientRect();
                    const tableBottom = tableRect.bottom;
                    
                    if (tableRect.top < 0 && tableBottom > 100) {
                        theadClone.style.display = 'table';
                        theadClone.style.width = table.offsetWidth + 'px';
                    } else {
                        theadClone.style.display = 'none';
                    }
                });
            }
        });
